import { Component, OnInit } from '@angular/core';
import { UnlServiceService } from "../../services/unl-service.service";
import { HttpClient } from "@angular/common/http";
import {
  Router, ActivatedRoute, ActivationEnd
} from "@angular/router";
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class VideoComponent implements OnInit {
  environmentType = environment.environmentType;
  videosrc1: any;
  nodeId: any;
  show: boolean = false;
  videotitle1: any;
  videolink1: string;
  location: Location;
  vidCatname: string;
  videooBject: any;
  res1: Object;
  share: any;
  videotitle: any;
  videosrc: string;
  videolink: string;

  constructor(
    private unlServiceService: UnlServiceService,
    private router: Router,
    private http: HttpClient,
    location: Location,
    private activeRoute: ActivatedRoute,
  ) {
    this.location = location;
    router.events.subscribe(event => {
      if (event instanceof ActivationEnd) {
        this.videosrc1 = null;
        const routeParams = this.activeRoute.snapshot.params;
        this.nodeId = routeParams.nodeId;
        // this.ngNavigatorShareService = ngNavigatorShareService;
      }
    });
  }

  ngOnInit(): void {

    const fullPath = this.router.url;
    const match = fullPath.match(/\d+/);

    if (match) {
      this.nodeId = match[0];

    }

    this.videooBject = this.unlServiceService.sendvpd();
    if (this.videooBject !== undefined && this.videooBject['crr'] !== undefined) {
      this.show = true;
      this.videosrc1 = this.videooBject['crr'];
      this.videotitle1 = this.videooBject['title'];
      this.vidCatname = this.videooBject['vidCatname'];
      this.videolink1 = this.videooBject['vidpath'];
      this.share = this.videooBject['share'];
      this.videosrc=this.videooBject['crr'];
      this.videotitle=this.videooBject['title'];
      this.vidCatname=this.videooBject['vidCatname'];
    this.videolink = this.videooBject['vidpath'];
    } else {
      this.http.get(
        this.unlServiceService.nodeurl +
        this.nodeId +
        this.unlServiceService.desc_Page
      ).subscribe((res: any) => {
        console.log(res);
        if (res.converted_videos) {
          this.videosrc1 = this.unlServiceService.basepath + res['converted_videos'].sd_mp4;
          this.videolink1 = this.unlServiceService.basepath + res['path'].replace(/^\//g, '');
        } else {
          this.vidCatname = 'Live';
          this.videosrc1 = res.field_live_video[0].value;
        }
        this.videotitle = res['title']
        this.videosrc = this.unlServiceService.basepath + res['converted_videos'].sd_mp4;
       this.videolink = this.unlServiceService.basepath + res['path'].replace(/^\//g, '');
        this.show = true;
        this.videotitle1 = res['title']
        const vidlink = {
          title: this.videotitle,
          text: this.videotitle,
          vidCatname: this.vidCatname,
          url:  this.videolink,
          description: res.body,
          platform: 'all'
        }
        //this.unlServiceService.updateVideo(vidlink);
        this.unlServiceService.getvideodetails(vidlink);
      });
    }
  }

  closePage() {
    this.location.back()
  }
}